/*global window, document, dataLayer, jQuery, localStorage, theme*/
var fmcImagePath = 'https://yakima-production.s3.amazonaws.com/fmc/';
var rootPath = window.location.href;
var yakimaApiUrl = 'https://go.yakima.com/api/';
var yakimaApiUrl2 = 'https://go.yakima.com/api';
var roofTypeIds = [];
var roofTypeNames = [];
var currentSku = '';
var pageLoaded = false;
var fitId = localStorage.getItem('fitId');


var _dcq = _dcq || [];
var _dcs = _dcs || {};
_dcs.account = '3994549';


(function () {


    //console.log('execute geolocation', "https://api.ipinfo.io/lite/me?token=3dd18231f6dd5d");

    
    fetch('https://api.ipinfo.io/lite/me?token=3dd18231f6dd5d')
    .then(response => response.json())
    .then(ip => {
        console.log("Country Code:", ip.country_code); 
        if(ip.country_code == "CA") {
            console.log('country is Canada');
            localStorage.setItem('ipCountry', 'ca');
            $('body').removeClass('geo-ready us');
            $('body').addClass('geo-ready ca');
        }
    })
    .catch(error => console.error("Error fetching country:", error));
 
  
})();



if (window.location.href.indexOf('localhost') >= 0) {
    yakimaApiUrl = window.location.href.substring(0, window.location.href.lastIndexOf('/')) + '/api';
}

if (rootPath.indexOf('www.yakima.com') >= 0) {
    rootPath = 'https://www.yakima.com';
} else if (rootPath.indexOf('uat') >= 0) {
    yakimaApiUrl = 'https://api.yakima.com/api/';
    rootPath = 'https://uat1-yakima.robofirm.net/';
}

jQuery(document).ready(function ($) {
    'use strict';

      
  
    jQuery('#get_started_button').bind("click tap", function (e) {
        fmcModalInit();
        e.preventDefault();
    });

    if (window.location.href.indexOf('modal=1') > 0) {
        fmcModalInit();
    }
    if (window.location.href.indexOf('vehicleId=') > 0) {
        var vehicleId = window.location.href.substring(window.location.href.indexOf('vehicleId=') + 10);
        console.log('vehicleId', vehicleId);
        var url = yakimaApiUrl2 + '/Vehicle/GetVehicleById/' + vehicleId;
        console.log(url);
        jQuery.get(url, function (data) {
        console.log(data);
            localStorage.setItem('fitId', 0);
            localStorage.setItem('vehicleId', vehicleId);
            localStorage.setItem('year', data.endYear);
            localStorage.setItem('makeId', data.makeId);
            localStorage.setItem('make-name', data.makeName);
            localStorage.setItem('modelId', data.modelId);
            localStorage.setItem('model-name', data.modelName);
            localStorage.setItem('rooftypeId', 1);
            setFMCVehicle();

        });
    }
    if (jQuery('body').hasClass('catalog-product-view') || jQuery('body').hasClass('template-product')) {
        currentSku = jQuery('.sku').first().text().replace('SKU: #', '');


        if (currentSku.length > 0) {
            fitCheck();

            jQuery('.product-options .cs-select').bind("change", function (e) {
                currentSku = jQuery('.sku').first().text().replace('SKU: #', '');
                if (rootPath.indexOf('jetstream') >= 0 && jQuery(this).closest('dd.last').length() == 0) {
                    console.log('Here we go');
                }
                fitCheck();
            });

        }
    }
    if (jQuery('body').hasClass('template-collection')) {
      setTimeout(function() {
     // console.log('template collection - delay');
    //    categoryPage();
        }, 2500);
    }
    if (window.location.href.indexOf('/windshield') > 0) {
        windshieldPage();
    }
    cartPopup();
    setFMCVehicle();
    


    pageLoaded = true;
});



window.addEventListener('searchspring.yakima.domReady',  e =>  console.log('domready'));

window.addEventListener('searchspring.afterSearch',  e =>  setTimeout(function() { categoryPage() }, 1000));

function fmcModalInit() {
    jQuery('#fmc-modalbackground').show();
    jQuery('#fmc-container').show();
    jQuery('.white-header').css('height', 0);
    jQuery('#fmc-container').html('<div id="fmc-header"><span class="fmc-title">Add Your Vehicle</span><span class="close">X CLOSE</span></div><div id="fmc-step1" class="third"><div class="content"></div></div><div id="fmc-step2" class="third"><div class="content"></div></div><div id="fmc-step3" class="third"><div class="content"></div></div>');

    jQuery('#fmc-step1').append('<div class="fmc-modal-vehicle"><span class="name"></span><a href="">Edit</a><hr/></div>');
    jQuery('#fmc-step1 .content').html('<h3>Tell us about your vehicle.</h3><p>Please Enter Your Vehicle Year, Make and Model<br/>That way we can give you the best fit for your vehicle. </p><select id="year-selector"></select><select id="make-selector"></select><select id="model-selector"></select><select id="type-selector"></select><select id="bedlength-selector"></select>');

    jQuery('#fmc-step2').append('<div class="fmc-modal-vehicle"><span class="name"></span><a href="">Edit</a><hr/></div>');
    resetSteps();

    loadYears();
    jQuery('#fmc-container .close').click(function () {
        jQuery('#fmc-container').hide();
        jQuery('#fmc-modalbackground').hide();
       jQuery('.white-header').css('height', '50px');


    });
    jQuery('.fmc-modal-vehicle a').bind("click tap", function (e) {
        jQuery(this).parent().parent().removeClass('selected');
        e.preventDefault();
    });
    jQuery('#year-selector').focus();
}
function clearLocalStorage() {
  
  var partnerId = localStorage.getItem('partnerId');
  var ipCountry = localStorage.getItem('ipCountry');
  var subscribeSeen = localStorage.getItem('subscribe-seen');
  var klaviyo = localStorage.getItem('klaviyoOnsite');
  localStorage.clear();
  if (partnerId)
    localStorage.setItem('partnerId', partnerId);
  if (ipCountry)
    localStorage.setItem('ipCountry', ipCountry);
  if (subscribeSeen)
    localStorage.setItem('subscribe-seen', subscribeSeen);
  if (klaviyo)
    localStorage.setItem('klaviyoOnsite', klaviyo);
}
function resetSteps() {
    jQuery('#fmc-step2 .content').addClass('blur').html('<h3>What does your vehicle roof look like?</h3><pThe roof of the vehicle determines the roof rack.</p><div class="option crossbars"><img src="https://yakima-production.s3.amazonaws.com/fmc/car-hasrack.jpg"><h3>My vehicle has crossbars</h3><p>Crossbars run perpendicular to the roof.</p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/naked-roof.jpg"><h3>My vehicle roof is \'naked\'</h3><p>There is nothing on the roof at all.</p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/flush-siderails.jpg"><h3>My Vehicle roof has Flush Side Rails.</h3><p>Flush side rails run parrallel to the doors and are flush to the roof surface.</p></div>');
    jQuery('#fmc-step3 .content').addClass('blur').html('<h3>What kind of crossbars does you roof rack have?</h3><p>Please complete the section to move on to the next step.</p><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/jetstream.png"><h3>JetStream</h3></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/corebar.png"><h3>CoreBar</h3><p></p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/hdbar.png"><h3>HDBar</h3><p>﻿</p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/roundbar.png"><h3>RoundBar</h3><p></p></div>');

}
function loadYears() {
    jQuery('#year-selector').html(jQuery('<option></option>').attr('value', '').text('Year'));
    jQuery('#model-selector').addClass('disabled').append(jQuery('<option></option>').attr('value', '').text('Model'));
    jQuery('#make-selector').addClass('disabled').append(jQuery('<option></option>').attr('value', '').text('Make'));
    for (year = new Date().getFullYear() + 1; year >= new Date().getFullYear() - 39; year--) {
        $option = jQuery('<option></option>').attr('value', year).text(year);
        jQuery('#year-selector').append($option);
    }
    if (localStorage.getItem('year')) {
        jQuery('#year-selector').val(localStorage.getItem('year'));
        yearSelected(jQuery('#year-selector'));
        jQuery('#make-selector').show().removeClass('disabled');
    }
    jQuery('#year-selector').change(function () {
        jQuery('#make-selector').show().removeClass('disabled');
        jQuery('#fmc-step2').removeClass('selected');
        year = jQuery('#year-selector').val();
       clearLocalStorage();
        resetSteps();
        localStorage.setItem('year', year);
        yearSelected();
        jQuery('#model-selector').html(jQuery('<option></option>').attr('value', '').text('Model'));

    });
}
function yearSelected(el) {
    year = jQuery('#year-selector').val();

    if (!year) {
        return;
    }
    jQuery('#make-selector').html(jQuery('<option></option>').attr('value', '').text('Make'));
    url = yakimaApiUrl2 + '/make/GetMakes/' + year + '/true/true/1';
    jQuery.get(url, function (data) {
        if (typeof data == 'object') {
            jQuery('#model-selector').removeClass('disabled');
            jQuery.each(data, function (i, e) {
                var selected = false;
                if (localStorage.getItem('makeId') && e.value == localStorage.getItem('makeId'))
                    selected = true;
                if (typeof e.id !== 'undefined' && typeof e.name !== 'undefined') {
                    $option = jQuery('<option></option>').attr('value', e.id).text(e.name);
                    jQuery('#make-selector').append($option);
                }
            });
        }
        if (localStorage.getItem('makeId')) {
            jQuery('#make-selector').val(localStorage.getItem('makeId'));
            makeSelected(jQuery('#make-selector'));
        //    jQuery('#make-selector').removeClass('disabled');
        }
        jQuery('#make-selector').change(function () {
            jQuery('#model-selector').show().removeClass('disabled');
            jQuery('#fmc-step2').removeClass('selected');

            year = jQuery('#year-selector').val();
            makeId = jQuery('#make-selector').val();
            makeName = jQuery('#make-selector option:selected').text();
            clearLocalStorage();
            resetSteps();
            localStorage.setItem('year', year);
            localStorage.setItem('makeId', makeId);
            localStorage.setItem('make-name', makeName);
            makeSelected();

        });
    });

    jQuery('#bedlength-selector').hide();
    jQuery('#type-selector').hide();
}

function makeSelected() {
    makeId = jQuery('#make-selector').val();
    if (!year || !makeId) {
        return;
    }
    url = yakimaApiUrl2 + '/model/GetModels/' + year + '/' + makeId + '/true/true/1';

    jQuery.get(url, function (data) {
        jQuery('#model-selector').html('');
        if (typeof data == 'object') {
            jQuery('#model-selector').append(jQuery('<option></option>').attr('value', '').text('Model'));
            jQuery('#make-selector').removeClass('disabled');
            jQuery.each(data, function (i, e) {
                if (typeof e.id !== 'undefined' && typeof e.name !== 'undefined')
                    jQuery('#model-selector').append(jQuery('<option></option>').attr('value', e.id).text(e.name));
            });
        }

        if (localStorage.getItem('modelId')) {
            jQuery('#model-selector').val(localStorage.getItem('modelId'));
            if(jQuery('#model-selector').val())
                modelSelected();
        }
        jQuery('#model-selector').change(function () {
            if (jQuery('#model-selector').val() != localStorage.getItem('modelId')) {
                jQuery('#fmc-step2').removeClass('selected');

                year = jQuery('#year-selector').val();
                makeId = jQuery('#make-selector').val();
                makeName = jQuery('#make-selector option:selected').text();
                clearLocalStorage();
                resetSteps();
                localStorage.setItem('year', year);
                localStorage.setItem('makeId', makeId);
                localStorage.setItem('make-name', makeName);
                localStorage.setItem('modelId', jQuery('#model-selector').val());
                localStorage.setItem('model-name', jQuery('#model-selector option:selected').text());
                modelSelected();

            }
        });
        jQuery('#bedlength-selector').hide();
        jQuery('#type-selector').hide();
    });
}

function modelSelected() {
    jQuery('#type-selector').html('');
    modelId = jQuery('#model-selector').val();
    if (!year || !makeId) {
        return;
    }
    url = yakimaApiUrl2 + '/vehicletype/GetVehicleTypes/' + year + '/' + makeId + '/' + modelId;
  console.log(url);
    jQuery.get(url, function (data) {
        if (typeof data == 'object') {

            jQuery('#type-selector').html('');
            if (data.length > 1) {
                jQuery('#type-selector').append(jQuery('<option></option>').attr('value', '').text('Variant'));
                jQuery('#type-selector').show();
                jQuery.each(data, function (i, e) {
                    if (typeof e.id !== 'undefined' && typeof e.name !== 'undefined')
                        jQuery('#type-selector').append(jQuery('<option></option>').attr('value', e.id).text(e.name));
                });
            }
            else {
                jQuery('#type-selector').hide();
                selectVehicle();
            }
        }

        if (localStorage.getItem('vehicleId')) {
            jQuery('#type-selector').val(localStorage.getItem('vehicleId'));
            if (jQuery('#type-selector').val())
                loadRoofTypes();
        }
        jQuery('#type-selector').change(function () {
            if (jQuery('#type-selector').val() != localStorage.getItem('vehicleId')) {

                jQuery('#fmc-step2').removeClass('selected');
                year = jQuery('#year-selector').val();
                makeId = jQuery('#make-selector').val();
                makeName = jQuery('#make-selector option:selected').text();
                modelId = jQuery('#model-selector').val();
                jQuery('#fmc-step1').addClass('selected');
                clearLocalStorage();
                resetSteps();
                localStorage.setItem('year', year);
                localStorage.setItem('makeId', makeId);
                localStorage.setItem('make-name', makeName);
                localStorage.setItem('modelId', modelId);
              var vehType = jQuery('#type-selector option:selected').text();
                localStorage.setItem('vehicle-type', vehType);

                localStorage.setItem('model-name', jQuery('#model-selector option:selected').text());
                localStorage.setItem('vehicleId', jQuery('#type-selector').val());
                loadRoofTypes();
                if(vehType == '5dr' || vehType == 'Wagon') {
                   localStorage.setItem('modFit', 'true');
                }
               else {
                   localStorage.setItem('modFit', '');
               }
            }
        });
        jQuery('#bedlength-selector').hide();
    });
}
function addProductsToCart(skuList) {
   
      var cartItems = [];
 fetch('/cart/clear.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  }
})
.then(response => response.json())
.then(data => {
  console.log('Cart successfully cleared:', data);
  // Optional: Reload the page to update the UI
  window.location.reload(); 
})
.catch((error) => {
  console.error('Error clearing cart:', error);
});

      var skus = skuList.split(',');
      skus.forEach((sku) => {
        cartItems.push({ 'id': sku, 'quantity': 1 });
        });


        let cartItemList = { 'items': cartItems };
            console.log(window.Shopify?.routes?.root + 'cart/add.js', JSON.stringify(cartItemList));

                fetch(window.Shopify?.routes?.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(cartItemList)
                })
                .then(response => {
                    
                  window.location = window.location.href + '?showCart=1';
                return response.json();
                })
                .catch((error) => {
                console.log('Error:', error);
                });
       
}
function selectVehicle() {
    var model = localStorage.getItem('modelId');
    var modelName = jQuery('#model-selector option:selected').text();


    localStorage.setItem('model-name', modelName);
    if (model.length > 0) {
        jQuery('#fmc-step1 .fmc-modal-vehicle .name').text(localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name'));

    }

    jQuery('#fmc-step2 .content').removeClass('top-selected');
    var url = yakimaApiUrl2 + '/vehicle/GetVehicle/' + localStorage.getItem('year') + '/' + localStorage.getItem('makeId') + '/' + model + '/0/1';
    console.log(url);
  jQuery.get(url, function (data) {
    console.log(data);
        if (typeof data == 'object') {
            localStorage.setItem("isTruck", data[0].class == 2);
            localStorage.setItem("modFit", data[0].modFitCount > 0 || data[0].typeId == 3 || data[0].typeId == 6);
            if (data[0].class == 2) {
                jQuery('#bedlength-selector').show().empty();
                jQuery('#bedlength-selector').append(jQuery('<option></option>').attr('value', '').text('Bed Length'));
              var cnt = 0;
                jQuery.each(data, function (i, e) {
                    var selected = false;
                    if (localStorage.getItem('vehicleId') && e.id == localStorage.getItem('vehicleId')) {
                        selected = true;
                        loadRoofTypes();
                    }
                    if (typeof e.id !== 'undefined' && typeof e.name !== 'undefined') {
                      if(e.name !== '') {
                        $option = jQuery('<option></option>').attr('value', e.id).text(e.name);
                        jQuery('#bedlength-selector').append($option);
                        cnt++;
                      }
                      else {
                        localStorage.setItem('vehicleId', e.id);
                      }
                    }
                  
                });
              if(cnt == 0) {
                    jQuery('#bedlength-selector').hide();
                        loadRoofTypes();
                        jQuery('#fmc-step1').addClass('selected');
                  }
              else if (localStorage.getItem('vehicleId')) {
                    jQuery('#bedlength-selector').val(localStorage.getItem('vehicleId'));
                }
//console.log('roof count', cnt);
              //  if(cnt < 2) {
             //     jQuery('#bedlength-selector').selectedIndex = 2;
              //    localStorage.setItem('vehicleId', jQuery('#bedlength-selector').val());
               //     localStorage.setItem('vehicle-type', jQuery('#bedlength-selector option:selected').text() + '  inch bed');
               //     loadRoofTypes();
               //     jQuery('#fmc-step1').addClass('selected');
               //   jQuery('#bedlength-selector').hide();
               // }
                jQuery('#bedlength-selector').change(function () {
                    if (jQuery('#bedlength-selector').val() != localStorage.getItem('vehicleId')) {
                        localStorage.setItem('vehicleId', jQuery('#bedlength-selector').val());
                        localStorage.setItem('vehicle-type', jQuery('#bedlength-selector option:selected').text() + '  inch bed');
                        loadRoofTypes();
                        jQuery('#fmc-step1').addClass('selected');

                    }
                });
            }
            else {
                localStorage.setItem("vehicleId", data[0].id);
                jQuery('#bedlength-selector').hide();
                loadRoofTypes();
                jQuery('#fmc-step1').addClass('selected');
            }
        }
    });
}

function selectSystem() {

    if (!jQuery('#select-system').hasClass('disabled')) {
        var rooftypeId = localStorage.getItem('rooftypeId');
        var rooftypeStatus = localStorage.getItem('rooftypeStatus');
        var systemPage = jQuery('#shopify-section-system-template').length > 0;
        var productPage = jQuery('body.catalog-product-view').length > 0;
        var towerCat = window.location.href.indexOf('product-type/tower-system') > 0;
        var isTruck = localStorage.getItem('isTruck') ;
        var container = '<div id="fmc-modal-container" class="ajax-success-message modal-container active reversed"><div class="ajax-success-message modal-content"><div class="content">';


        dataLayer.push({
            'event': 'cftProgress',
            'step': {
                'name': 'Car Fit Tool - Selected',
                'vpv': '/vpv/car-fit-tool/selected'
            },
            'vehicleData': {
                'make': '' + localStorage.getItem('make-name') + '',
                'model': '' + localStorage.getItem('model-name') + '',
                'year': '' + localStorage.getItem('year') + '',
                'roofType': '' + localStorage.getItem('rooftypeName').replace('My vehicle has ', '') + '',
                'system': '' + localStorage.getItem('system-name') + ''
            }
        });
        var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
        if (localStorage.getItem('vehicle-type'))
            vehName = vehName + ' ' + localStorage.getItem('vehicle-type');
        var roofType = localStorage.getItem('rooftypeName').replace('My vehicle has ', '').replace('I have a ', '').replace('I have ', '');
        if (roofType == 'crossbars') {
            if (localStorage.getItem('system-name') == 'BaseLine' || localStorage.getItem('system-name') == 'QTower' || localStorage.getItem('system-name') == '1A Raingutter' || localStorage.getItem('system-name') == 'Control Tower') {
                roofType = 'naked roof';
                rooftypeId = '1';
            }
            else if (localStorage.getItem('system-name') == 'SkyLine' || localStorage.getItem('system-name') == 'Yakima FlushBar' || localStorage.getItem('system-name') == 'RidgeLine') {
                roofType = 'flush siderails';
                rooftypeId = '12';
            }
            else if (localStorage.getItem('system-name') == 'TimberLine' || localStorage.getItem('system-name') == 'Yakima RailBar' || localStorage.getItem('system-name') == 'RailGrab') {
                roofType = 'raised siderails';
                rooftypeId = '4';
            }

        }

        dataLayer.push({
            'event': 'fmcSelect',
            'fmcVehicle': '' + vehName,
            'fmcRooftype': '' + roofType + '',
            'fmcRooftypeId': '' + rooftypeId + '',
            'fmcVehicleId': '' + localStorage.getItem('vehicleId')
        });

        if (localStorage.getItem('fitId') && parseInt(localStorage.getItem('fitId')) > 0) {
            dataLayer.push({
                'event': 'fmcFitSelect',
                'action': 'existing',
                'fmcFitId': '' + localStorage.getItem('fitId')
            });
          if (window.location.href.indexOf('retailer-fmc') > 0 || window.location.href.indexOf('configurator') > 0) {
            window.location = '/collections/all';
        	}
        }
        console.log('make:' + localStorage.getItem('make-name') + '|model:' + localStorage.getItem('model-name') + '|year:' + localStorage.getItem('year') + '|roofType:' + localStorage.getItem('rooftypeName').replace('My vehicle has ', '') + '|system:' + localStorage.getItem('system-name') + '');

        if (rooftypeStatus == '5' && isTruck != 'true')
            jQuery('body').first().append(container + '<p><b>Unfortunately, our Fit Team has not yet fit your vehicle with a roof rack system.</b><br/>Your friendly neighbors at Yakima are looking for this vehicle. <br/>If you are interested in volunteering your vehicle to be fit by our Fit Team at our Lake Oswego, Oregon location, please enter your email and we will be in touch.<br/><input type="text" id="vap-email"></input></p><div class="actions"><a class="button reversed outline" onclick="VAPEmail()">Submit</a><a onclick="window.location.reload();" class="button reversed close">No Thanks</a></div></div></div>');
        else if ((localStorage.getItem('noRoofFit') == 'true' || rooftypeStatus == '-1') && isTruck != 'true') {
            if(localStorage.getItem('modFit') == 'true')
                 jQuery('body').first().append(container + '<p>Unfortunately we do not have a roof rack system that fits your vehicle, but you can try our new inside-the-car MOD system. Shop now!</p><div class="actions"><a class="button reversed outline" href="https://yakima.com/pages/custom-solutions">Custom Solutions</a><a class="button reversed outline" href="/products/mod-system">MOD System</a><br/><a onclick="reloadPage();" class="button reversed close" style="display: inline-block;margin-top: 30px;">No Thanks</a></div></div></div>');
            else 
                jQuery('body').first().append(container + '<p>Unfortunately we do not have a roof rack system that fits your vehicle. </p><div class="actions"><a class="button reversed outline" href="https://yakima.com/pages/custom-solutions">Custom Solutions</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');
        }
          else if (fitId == -4)
            jQuery('body').first().append(container + '<p><b>For Your Safety we cannot confirm compatibility with non-Yakima Roof Rack Systems.</b><br/>However, you\'re more than welcome to shop and purchase any Yakima products with this in mind.  Our products do fit nearly any crossbar shape - but again, we cannot confirm compatibility and fullfill product and gear warranty with a non-Yakima rack system.</p><div class="actions"><a onclick="reloadPage();" class="button reversed close">I Understand</a></div></div></div>');
        else if (isTruck == 'true' && localStorage.getItem('truckbedId') == '-2')
            jQuery('body').first().append(container + '<p>Unfortunately we do not have a roof rack system that fits your truckcap.</p><div class="actions"><a class="button reversed outline" href="https://yakima.com/pages/custom-solutions">Custom Solutions</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');

        else if (fitId == -2 )
            jQuery('body').first().append(container + '<p>Interested in carrying more gear on your truck? Roof racks are the foundation of any adventure big or small. Shop now!</p><div class="actions"><a class="button reversed outline" href="/product-type/tower-system">Shop Systems</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');
         else if ((fitId == 0 || fitId == -3) && !systemPage && !towerCat && !productPage) {
           var systemPage = '/collections/roof-rack-systems';
           if(isTruck == 'true')
                  systemPage = '/collections/truck-rack-systems';
           if(isTruck == 'true' && localStorage.getItem('rooftypeId') == '1')
                 jQuery('body').first().append(container + '<p>Interested in carrying more gear? Rack Systems are the foundation of any adventure big or small. Shop now!</p><div class="actions"><a class="button reversed outline" href="/collections/roof-rack-systems">Roof Systems</a><a class="button reversed outline" href="/collections/truck-rack-systems">TruckBed Systems</a><br/><a onclick="reloadPage();" class="button reversed close" style="display: inline-block;margin-top: 30px;">No Thanks</a></div></div></div>');
			else if(localStorage.getItem('modFit') == 'true')
                 jQuery('body').first().append(container + '<p>Interested in carrying more gear? Your vehicle can fit either a roof rack or our new inside-the-car MOD system. Shop now!</p><div class="actions"><a class="button reversed outline" href="/collections/roof-rack-systems">Roof Systems</a><a class="button reversed outline" href="/products/mod-system">MOD System</a><br/><a onclick="reloadPage();" class="button reversed close" style="display: inline-block;margin-top: 30px;">No Thanks</a></div></div></div>');

           else
              jQuery('body').first().append(container + '<p>Interested in carrying more gear? Rack Systems are the foundation of any adventure big or small. Shop now!</p><div class="actions"><a class="button reversed outline" href="' + systemPage + '">Shop Rack Systems</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');

           
        }
        else if (window.location.href.indexOf('retailer-fmc') > 0 || window.location.href.indexOf('configurator') > 0) {
            window.location = '/collections/all';
        }
        else {
         //   setCurrentFit();
            if (window.location.href.indexOf('stayput') <= 0) {
                if (window.location.href.indexOf('modal') > 0)
                    window.location = window.location.href.replace('?modal=1', '');
                else
                        window.location.reload();

            }
        }
        jQuery('#fmc-container').hide();
        jQuery('#fmc-modalbackground').hide();
        jQuery('.white-header').css('height', 'auto');



    }
}
function VAPEmail() {
    var email = jQuery('#vap-email').val();
    if (email.length == 0)
        alert('Please enter your email address');
  else if (localStorage.getItem('vap-submit')) {
        alert('Your request was already submitted, thank you.');
                window.location.reload();
  }
    else {
        var vehicle = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name') + ' with ' + localStorage.getItem('rooftypeName').replace('I have ', '');
        _dcq.push(["identify", {
            email: email,
            vap_request: vehicle,
            success: function (response) {
               localStorage.setItem('vap-submit', '1');
                window.location.reload();
            }
        }]);
        //
        var url = yakimaApiUrl2 + '/vap/SendEmail/' + email + '/' + vehicle;
        jQuery.post(url, function (data) {
          console.log('sendemail', data);
            window.location.reload();


        });
       alert('Thank you, our Fit team will be in touch');
      window.location.reload();
    }
}
function reloadPage() {

    if (window.location.href.indexOf('modal') > 0)
        window.location = window.location.href.replace('?modal=1', '');
    else
        window.location.reload();
}
function closeFMCModal() {
    jQuery('#fmc-modal-container').remove();

}
function checkInventory(sku) {
    if (sku && sku.length > 0) {
        var url = yakimaApiUrl2 + '/inventory/GetInventoryValue/' + sku;
        jQuery.get(url, function (data) {
            return parseInt(data);


        });
    }
}
function loadRoofTypes() {
    jQuery('#fmc-step2 .content').removeClass('blur');

    if (localStorage.getItem('isTruck') == 'true') {
        jQuery('#fmc-step2').addClass('scroll');
        jQuery('#fmc-step2 .content').empty().append('<h3>1) What does your vehicle roof look like?</h3><a href="" class="edit-crossbars">Edit</a>');
    }
    else {
        jQuery('#fmc-step2').removeClass('scroll');
        jQuery('#fmc-step2 .content').empty().append('<h3>What does your vehicle roof look like?</h3><p>The roof of the vehicle determines the roof rack.</p>');
    }
    jQuery('#fmc-step2 .content').append('<div class="option toc crossbars" data-id="0"><img src="' + fmcImagePath + 'car-hasrack.jpg"/><h3>My vehicle has crossbars</h3><p>Crossbars run perpendicular to the roof.</p></div>');

      var url = yakimaApiUrl2 + '/rooftype/GetRoofTypes/' + localStorage.getItem('vehicleId') + '/true/true';
    console.log(url);
      roofTypeIds = [];
      roofTypeNames = [];
  
      jQuery.get(url, function (data) {
          if (typeof data == 'object') {
              var cnt = 0;
            
              $option = jQuery('<option></option>').attr('value', 0).text('Select Roof Type');
              jQuery('.inline-fmc #rooftype-selector').show().empty().append($option);
              jQuery.each(data, function (i, e) {
                  if (typeof e.id !== 'undefined') {
                      var cls = '';
                    //  if (e.Id == 14 && jQuery('#fmc-step2 .content .option.naked-roof').length > 0) {
                          //Hide Naked Roof Fixed Point if Naked Roof exists
                   //   }
                  //    else
                    if(jQuery('#fmc-step2 .content .option.toc.' + e.img).length == 0) {
                          jQuery('#fmc-step2 .content').append('<div class="option toc ' + e.img + cls + '" data-id="' + e.id + '" data-status="' + e.statusId + '"><img src="' + fmcImagePath + e.img + '.jpg"/><h3>I have ' + e.name.toLowerCase() + '</h3><p>' + e.subHead + '</p></div>');
                   
                        $option = jQuery('<option></option>').attr('value', e.id).text(e.name);
                        jQuery('.inline-fmc #rooftype-selector').append($option);
                     
                        roofTypeIds[cnt] = e.id;
                        roofTypeNames[cnt] = e.name;
                        cnt++;
                    }
                    else {
                        if(e.statusId != 5) 
                            jQuery('#fmc-step2 .content .option.toc.' + e.img).attr('data-status', e.statusId);

                    }
                  }
              });
            
              localStorage.setItem('noRoofFit', cnt == 0);
              if (cnt == 0) {
                  jQuery('#fmc-step2 .content').append('<div class="option toc naked-roof" data-id="1"><img src="' + fmcImagePath + 'naked-roof.jpg"/><h3>I have a naked roof</h3><p>There is nothing on the roof at all.</p></div>');
  
              }
            if (localStorage.getItem('rooftypeId')) {
                jQuery('.inline-fmc #rooftype-selector').val(localStorage.getItem('rooftypeId'));
            }
          }
  

      jQuery('#fmc-step2 .content .option.toc').click(function () {
          jQuery('#fmc-step2 .content .option.toc.selected').removeClass('selected');
          jQuery(this).addClass('selected');
          localStorage.setItem('rooftypeId', jQuery(this).attr('data-id'));
          localStorage.setItem('rooftypeName', jQuery(this).find('h3').text());
          localStorage.setItem('rooftypeStatus', jQuery(this).attr('data-status'));
          localStorage.removeItem('bar-type');
          localStorage.removeItem('bar-size');

          if (localStorage.getItem('isTruck') !== 'true' || jQuery('#fmc-step2 .content .option.truck.selected').length > 0) {
              loadTowers();
              jQuery('#fmc-step2').addClass('selected');
          }
          jQuery('#fmc-step2 .name').text(jQuery(this).find('h3').text());
          jQuery('.truckOptions').removeClass('blur');

      });
        jQuery('.inline-fmc #rooftype-selector').change(function () {
          localStorage.setItem('rooftypeId', jQuery(this).val());
          localStorage.setItem('rooftypeName', jQuery(this).find('option:selected').text());
          localStorage.removeItem('bar-type');
          localStorage.removeItem('bar-size');
            fitCheck();
          if(jQuery('#collection-fmc').length > 0) {
           //  window.location.reload();
             if(localStorage.getItem('vehicleId') > 0){
                var url = yakimaApiUrl2 + '/fit/getSystems/US/' + localStorage.getItem('vehicleId') + '/' + jQuery(this).val();
                  jQuery.get(url, function (data) {
                      if (data.length > 0) {
                        localStorage.setItem('fitSystems', data);
                        categoryPage();
                      }
                   });
              }
               
          }
          if(jQuery('#shopify-section-system-template').length > 0)
            showTowerSystem();
          if(jQuery('#shopify-section-mod-system').length > 0)
            loadFit();
          
      });
      jQuery('#fmc-step2 .content .option').each(function () {
          if (localStorage.getItem('fitId') && localStorage.getItem('fitId') != '0' && jQuery(this).attr('data-id') == '0')
              jQuery(this).click();
          else if (localStorage.getItem('fitId') == '0' && parseInt(localStorage.getItem('rooftypeId')) == jQuery(this).attr('data-id')) {
              jQuery(this).click();
          }
      });
      jQuery('#fmc-step2 .content .edit-crossbars').bind("click tap", function (e) {
          jQuery('#fmc-step2 .content').removeClass('top-selected');
          e.preventDefault();
      });
      if (localStorage.getItem('isTruck') == 'true') {
          var cls = ' blur';
          if (jQuery('.option.toc.selected').length > 0)
              cls = '';
          jQuery('#fmc-step2 .content').append('<hr/>');
          jQuery('#fmc-step2 .content').append('<span class="truckOptions' + cls +'"><h3>2) What does your truck bed look like?</h3></span>');
          jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck empty" data-id="-1"><img src="' + fmcImagePath + 'truck-norack.jpg"/><h3>My truck bed is empty</h3><p>There is nothing in the bed or on the side rails. </p></div>');
          jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck crossbars" data-id="16"><img src="' + fmcImagePath + 'truck-hasrack.jpg"/><h3>I have crossbars across my empty truck bed.</h3><p>There are perpendicular crossbars over my truck bed.</p></div>');
          jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck truckcap" data-id="-2"><img src="' + fmcImagePath + 'truck-shell.jpg"/><h3>I have a truckcap</h3><p>There is a cap over the bed of my truck.</p></div>');
          jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck truckcap-bars" data-id="4"><img src="' + fmcImagePath + 'truck-shell-crossbars.jpg"/><h3>I have a truckcap with a roof rack</h3><p>The truck cap has a roof rack installed on top of it. </p></div>');
          jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck tonneau" data-id="-3"><img src="' + fmcImagePath + 'tonneau.jpg"/><h3>I have a Tonneau cover</h3><p>There is a Tonneau cover covering the truck bed.</p></div>');
          jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck tonneau tonneau-bars" data-id="16"><img src="' + fmcImagePath + 'tonneau-crossbars.jpg"/><h3>I have a tonneau cover with crossbars</h3><p>There is a Tonneau cover with crossbars covering the truck bed.</p></div>');
          jQuery('#fmc-step2 .content .select-roof').click(function () {
              localStorage.setItem('rooftypeId', '0');
              loadTowers();
          });
          jQuery('#fmc-step2 .content .option.truck').unbind().click(function () {
              jQuery('#fmc-step2 .content .option.truck.selected').removeClass('selected');
              jQuery(this).addClass('selected');
              localStorage.setItem('truckbedId', jQuery(this).attr('data-id'));
              localStorage.setItem('hasTonneau', jQuery(this).hasClass('tonneau'));
              if (jQuery('#fmc-step2 .content .option.toc.selected').length > 0) {
                  jQuery('#fmc-step2').addClass('selected');
                  loadTowers();
              }
          });
      }
      });
}

function loadTowers() {


    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var isTruck = localStorage.getItem('isTruck');

    var url = yakimaApiUrl2 + '/fit/getSystems/US/' + vehicleId + '/' + rooftypeId;
        console.log(url);
        jQuery.get(url, function (data) {
            if (data.length > 0) {
              localStorage.setItem('fitSystems', data);
            }
         });
    jQuery('#fmc-step3 .content').removeClass('blur');
    //if (localStorage.getItem('noRoofFit') == 'true') {
    //    jQuery('#fmc-step3').removeClass('scroll');


    //    jQuery('#fmc-step3 .content').empty().append('<h3 class="center vcenter">No Fits Found.</h3><p class="center">Unfortunately we do not currently have a roof rack system that fits your vehicle. However, other Yakima products are available that fit nearly any car universally without a roof rack system. Also, learn more about a custom solution for your vehicle from our partners.</p>');
    //    jQuery('#fmc-step3 .fmc-save').remove();
    //    jQuery('#fmc-step3 .content').append('<p><a class="external" href="/product-type/universal" id="nofit-continue">Shop Universal Products</a> <a  class="external" href="https://yakima.com/pages/custom-solutions" id="nofit-custom">Custom Solutions</a></p>');

    //}
    //else if (localStorage.getItem('rooftypeStatus') == '5') {
    //    jQuery('#fmc-step3').removeClass('scroll');
    //    jQuery('#fmc-step3 .content').empty().append('<h3 class="center vcenter">Unfortunately at this time we do not have a roof rack system that fits your vehicle.</h3><p class="center">If you live in the Portland, OR metro area we\'d love to hook you up! Enter your email below to help out the Yakima Fit Team.<input type="text" id="vap-email"></input><div class="actions"><a class="button reversed outline" onclick="VAPEmail()">Submit</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></p>');
    //    jQuery('#fmc-step3 .fmc-save').remove();
    //}
    if ((rooftypeId != '0' && isTruck != 'true') || (isTruck && (localStorage.getItem('rooftypeId') == '1' || localStorage.getItem('rooftypeId') == '3' || localStorage.getItem('rooftypeId') == '4')  && (localStorage.getItem('truckbedId') == '-1' || localStorage.getItem('truckbedId') == '-2' || localStorage.getItem('truckbedId') == '-3'))) {
        jQuery('#fmc-step3').removeClass('scroll');
        jQuery('#fmc-step3 .content').empty().append('<h3 class="center vcenter">Great! Let\'s roll.</h3><p class="center">Now you can search for products that fit to your vehicle type. Click Save below to begin your search.</p>');
        jQuery('#fmc-step3 .fmc-save').remove();
        jQuery('#fmc-step3 .content').append('<div class="fmc-save"><button onclick="selectSystem()" id="select-system">Save</button></div>');

        if (localStorage.getItem('truckbedId') == '-2' || localStorage.getItem('truckbedId') == '-3')
            fitId = -3;
        else
            fitId = 0;
        localStorage.setItem('fitId', fitId);
        localStorage.setItem('system-name','');
        localStorage.setItem('crossbarMin','');
        localStorage.setItem('fitSkus', '');

        
              
    }
    else {

        jQuery('#fmc-step3 .content').empty().append('<h3>What rack system?</h3>');

        if (isTruck == 'true' && localStorage.getItem('rooftypeId') != '0')
            rooftypeId = '16';
        if(localStorage.getItem('truckbedId') == '4')
            rooftypeId = '4';

        var includeTruck = 'false';
        var excludeRoofType = 0;
        if (isTruck == 'true' && localStorage.getItem('truckbedId') == '16')
            includeTruck = 'true';
        if (isTruck == 'true' && localStorage.getItem('truckbedId') == '-1')
            excludeRoofType = '16';
          var url = yakimaApiUrl2 + '/fit/getFits/US/' + vehicleId + '/' + rooftypeId + '/true/false/false/false/true/' + excludeRoofType + '/' + includeTruck + '/true/false';
        console.log(url);
        var container = "";

        if (isTruck == 'true') {
            jQuery('#fmc-step3 .content').append('<select id="rooftype-selector"><option value="0">Select Mount Location</option></select>');
            jQuery('#fmc-step3 .content select').append('<option value="1">Roof</option>');
            jQuery('#fmc-step3 .content select').append('<option value="16">Truck Bed</option>');
        }
        else if (rooftypeId == 0 && roofTypeIds.length > 1) {
            jQuery('#fmc-step3 .content').append('<select id="rooftype-selector"><option value="0">Showing All</option></select>');
            for (i = 0; i < roofTypeIds.length; i++) {
                jQuery('#fmc-step3 .content select').append('<option value="' + roofTypeIds[i] + '">' + roofTypeNames[i] + '</option>');
            }

        }
        else {
            jQuery('#fmc-step3 .content').append('<div class="select-spacer"></div>');
        }
        jQuery('#fmc-step3 #rooftype-selector').change(function () {
            var rtId = jQuery('#fmc-step3 #rooftype-selector').val();
            jQuery('#fmc-step3 .content .option').show();
            jQuery('#fmc-step3 .content .option').each(function (index) {
                if (rtId != '0' && jQuery(this).attr('data-rooftype') != rtId && jQuery(this).attr('data-rooftype') != -1) {
                    jQuery(this).hide();
                }
            });
        });
        jQuery.get(url, function (data) {
            if (typeof data == 'object') {
                var cnt = 0;
                jQuery.each(data, function (i, e) {
                    if (typeof e.id !== 'undefined') {
                        var cls = '';
                        if (fitId == e.id) {
                            cls = ' selected';
                            jQuery('#select-system').removeClass('disabled');
                        }
                        if(jQuery('#fmc-step3 .content' + container + ' div[data-fittype=' + e.fitTypeId + ']').length == 0) {
                            if (localStorage.getItem('hasTonneau') == 'true' && (e.name.toLowerCase().indexOf('outdoorsman') >= 0 || e.name.toLowerCase().indexOf('bedrock') >= 0)) {
                                //Hide Outdoorsman and BedRock if vehicle has Tonneau cover
                            }
                            else {
                                jQuery('#fmc-step3 .content' + container).append('<div class="option' + cls + '" data-id="' + e.id + '" data-fittype="' + e.fitTypeId + '" data-rooftype="' + e.roofTypeId + '" data-minlength="' + e.minBarLength + '" data-status="' + e.statusId + '"><img src="' + fmcImagePath + e.name.toLowerCase().replace('yakima ', '').replace(' ', '-') + '.png"/><h3>' + e.name + ' System</h3><p>' + e.shortDesc + '</p></div>');
                                localStorage.removeItem('noRoofFit');
                            }
                        }
                    }
                });


                jQuery('#fmc-step3 .content').append('<div class="option thirdparty" data-id="-4" data-rooftype="-1"><img src="' + fmcImagePath + 'third-party.jpg"/><h3>Third Party or Custom Rack</h3><p>A system made by one of our competitors</p></div>');

                if (jQuery('#fmc-step3 .fmc-save').length == 0)
                    jQuery('#fmc-step3').append('<div class="fmc-save"><button onclick="selectSystem()" id="select-system" class="disabled">Save</button></div>');
                else
                    jQuery('#select-system').removeClass('disabled').addClass('disabled');

                if (jQuery('#fmc-step3 .content .option').length > 4)
                    jQuery('#fmc-step3').addClass('scroll');
                else
                    jQuery('#fmc-step3').removeClass('scroll');

                
                var rtId = jQuery('#fmc-step3 #rooftype-selector').val();


                jQuery('#fmc-step3 .content .option').click(function () {
                    jQuery('#fmc-step3 .content .option.selected').removeClass('selected');
                    jQuery(this).addClass('selected');
                    jQuery('#select-system').removeClass('disabled');
                    var selectedFit = jQuery(this).attr('data-id');
                    setFit(selectedFit);
                //    localStorage.setItem('rooftypeId', jQuery(this).attr('data-rooftype'));
                    var systemName = jQuery('#fmc-step3 .content .option.selected h3').first().text().replace(' System', '');
                    localStorage.setItem('system-name', systemName);
                    localStorage.setItem('crossbarMin', jQuery('#fmc-step3 .content .option.selected').first().attr('data-minlength'));
                });
                jQuery('#fmc-step3 .content .option').each(function () {
                    if (parseInt(localStorage.getItem('fitId')) == jQuery(this).attr('data-id')) {
                        jQuery(this).click();
                    }
                });
            }
        });


    }


}
function setFit(fitId) {
    localStorage.setItem('fitId', fitId);
      if(fitId > 0) {
        var url =  yakimaApiUrl2 + '/fitcheck/GetFitSkus/' + fitId;
          console.log(url);
          jQuery.get(url, function (data) {
              if (data.length > 0) {
                  localStorage.setItem('fitSkus', data);
              }
          });
      }
}
function setFMCVehicle() {
    if (localStorage.getItem('vehicleId')) {
        var fmcMsg = '';
        var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
        if(vehName.length > 15)
            vehName = vehName.substring(0, 15) + '...';
        fmcMsg = '<a id="get_started_button" class="caricon"> ' + vehName;
       
        fmcMsg += '</a> <a id="vehicle_remove" class="right-arrow-link" onclick="removeVehicle()"> <span>Remove</span></a>';

        jQuery('#fmc-add-vehicle').html(fmcMsg);

    }
    else {
        jQuery('#fmc-add-vehicle').html('<a id="get_started_button"><button class="get-started-button yakima-fmc caricon">Fit My Vehicle</button></a>');
    }
    jQuery('#get_started_button').bind("click tap", function (e) {
        fmcModalInit();
        e.preventDefault();
    });
}
function removeVehicle() {
    
  clearLocalStorage();
    fitId = 0;
    jQuery('#fmc-add-vehicle').html('<a id="get_started_button" class="notset"><span class="get-started-button yakima-fmc caricon">Fit My Vehicle</span></a>');
    jQuery('#fitCurrentVehicle').html('<p><span style="color: #CCCCCC;">&#149;</span> We need more information before confirming vehicle fit. <a href="#" onclick="fmcModalInit();">Continue</a>.</p>');
    jQuery('#get_started_button').bind("click tap", function (e) {
        fmcModalInit();

        e.preventDefault();
    });
   if (jQuery('body').hasClass('template-collection')) {
        window.location.reload();
    }
    fitCheck();
    if(jQuery('#shopify-section-system-template').length > 0)
            showTowerSystem();
}

function fitCheck() {
    var productFit = 0;
    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var href = window.location.href.toLowerCase();
    var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
    var isTent = false;
    var sku = jQuery('.product-single__meta .sku').first().text().replace('SKU: #', '');
    var systemPage = (jQuery('#shopify-section-system-template').length > 0);
    var isLNL = href.indexOf('locknload') > 0;
    var isMOD = href.indexOf('mod-') >= 0;
    var isCrossbar = !systemPage && (href.indexOf('jetstream') > 0 || href.indexOf('corebar') > 0 || href.indexOf('roundbar') > 0 || href.indexOf('line-fx') > 0);
    var truckSystem = href.indexOf('overhaul') > 0 || href.indexOf('outpost') > 0 || href.indexOf('bedrock') > 0 || href.indexOf('outdoorsman') > 0;

    if (localStorage.getItem('systemId') && systemPage)
        fitId = localStorage.getItem('systemId');
  	if(localStorage.getItem('fitId') == '0' && isLNL && localStorage.getItem('towerSystemId'))
      fitId = localStorage.getItem('towerSystemId');
  if(fitId == null || fitId == 'null')
    fitId = '0';

    if (sku == "8007406" || sku == "8007407" || sku == "8007434" || sku == "8007432" || sku == "8007436" || sku == "8007437")
        isTent = true;

    jQuery('.template-product').addClass('nofit');

   // if ((fitId && fitId.length > 0) || (vehicleId && vehicleId.length > 0 && rooftypeId && rooftypeId.length > 0)) {
        if (!fitId || fitId.length == 0 || isLNL)
            fitId = 0;
         if (!vehicleId || vehicleId.length == 0) vehicleId = 0;
         if (!rooftypeId || rooftypeId.length == 0) rooftypeId = 0;
        if (truckSystem && localStorage.getItem('truckbedId') == '-4') {
            if (isTent)
                setFitMessage('#666', 'We cannot confirm compatibility with your rack system, please read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>.', 'unknown');
            else
                setFitMessage('#666', 'We cannot confirm compatibility with your rack system.', 'unknown');
        }
        else if (truckSystem && localStorage.getItem('hasTonneau') == 'true' && ((href.indexOf('overhaul-hd-system') < 0 && href.indexOf('overhaul-hd-tonneau') < 0 && href.indexOf('outpost-hd-system') < 0) || localStorage.getItem('tonneauType') == 'tonneau-0')) {
            setFitMessage('Red', ' Does not fit your ' + vehName + '.');
        }
        else if (truckSystem && fitId == 0 && localStorage.getItem('truckbedId') == '-3') {
            if (isTent)
                setFitMessage('#666', 'Please contact the manufacturer of your Truck Shell/RV/Camper for their recommendation and options for carrying roof top tents, and read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>.', 'warning');
            else
                setFitMessage('#666', 'Please contact the manufacturer of your Truck Shell/RV/Camper for their recommendation and options for carrying Yakima products.</p>', 'unknown');
        }
        else if (truckSystem && localStorage.getItem('truckbedId') == '-2') {
            productFit = 1;
        }
        else if (href.indexOf('ruggedline-system') > 0) {
            if(vehicleId == 0) 
                setFitMessage('', '');
            else {

                productFit = 1;
                jQuery('.template-product').removeClass('nofit');
            }
        }
        else if ((vehicleId == null || vehicleId == 0) && (isTent || sku == 'tracktower-system')) {
            setFitMessage('#666', 'We need more information before confirming vehicle fit. <a href="#" onclick="fmcModalInit();">Continue</a>.', 'unknown');
        }
        else if (fitId == 0 && isTent) {
            setFitMessage('#666', 'We cannot confirm compatibility with your vehicle, please read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>. ', 'warning');

        }
       else if (vehicleId == null || vehicleId == 0) {
            setFitMessage('', '');

        }
   		else if (localStorage.getItem('fitId') == '-4' && vehicleId > 0)
                        setFitMessage('#666', 'We cannot confirm compatibility with your rack system. ', 'unknown');
        else if (localStorage.getItem('system-name') == 'Factory Rack' && isTent) {
            setFitMessage('Red', ' Does not fit your ' + vehName + '.', 'nofit');
        }

        else if (isCrossbar && vehicleId != null && vehicleId > 0 && sku != null && sku.length > 0) {
            setFitMessage('Yellow', 'Crossbar fit depends on several factors, please use our <a href="/collections/roof-rack-systems">Rack Systems</a> pages to ensure you have the correct sizes and components', 'warning');

        }
          else if (vehicleId != null && vehicleId > 0 && sku != null && sku.length > 0) {
            if (!isLNL && localStorage.getItem('isTruck') == 'true' && (localStorage.getItem('truck-placement') == null || localStorage.getItem('truck-placement') == 'truck-bed'))
                rooftypeId = '16';
           // var url = yakimaApiUrl + '/fitcheck/GetFitCheck?fitId=' + fitId + '&sku=' + sku + '&isSystem=' + systemPage + '&vehicleId=' + vehicleId + '&roofTypeId=' + rooftypeId;
            var url =  yakimaApiUrl2 + '/fitcheck/GetFitCheck/' + fitId + '/' + sku + '/' + vehicleId + '/' + rooftypeId;
          
            console.log(url);
            jQuery.get(url, function (data) {
                productFit = data > 0;

                if (data == 0) {
                    if (localStorage.getItem('vehicleId')) {
                     //   if (isLNL && fitId == 0)
                       //     setFitMessage('#666', 'Rack System Required (<a href="/product-type/tower-system">Shop</a>)', 'unknown');
                      //  else 
                          if (isLNL && fitId == -4) {
                            setFitMessage('#666', 'We cannot confirm compatibility with your vehicle, please read our <a href="https://assets.yakima.com/product/instructions/8005044/1" target="_blank">LockNLoad Vehicle Evaluation Guidelines and Best Practices</a>.', 'warning');
                            jQuery('.template-product').removeClass('nofit');
                        }
                        else if (systemPage && !isLNL)
                            setFitMessage('Red', ' Does not fit your ' + vehName + '.  Learn about <a href="https://yakima.com/pages/custom-solutions">custom solutions</a>.', 'nofit');
                        else
                            setFitMessage('Red', ' Does not fit your ' + vehName + '. ', 'nofit');
                    }
                    else {
                        setFitMessage('', '', 'unknown');
                    }
                }
                else if (data == -1) {
                    if (localStorage.getItem('rooftypeStatus') == '-1') //If this is a CFU or explicit NoFit
                        setFitMessage('Red', ' Does not fit your ' + vehName + '.  Learn about <a href="https://yakima.com/pages/custom-solutions">custom solutions</a>.', 'nofit');
                    else if (href.indexOf('ruggedline-hd') > 0) 
                    {
                      if(localStorage.getItem('vehicleId'))
                        setFitMessage('Yellow', 'Requires the Yakima LockNLoad Platform to complete the system.', 'warning');
                      else
                        setFitMessage('Yellow', 'Requires the Yakima LockNLoad Platform to complete the system.  Ensure your vehicle is selected in the Fit My Car tool. <a href="#" onclick="fmcModalInit();">Continue</a>.', 'warning');
      
                    }
                    else if (localStorage.getItem('vehicleId') && fitId == 0 && localStorage.getItem('isTruck') != 'true' && !isCrossbar)
                        setFitMessage('#666', 'Rack System Required (<a href="/product-type/tower-system">Shop</a>)', 'unknown');
                      
                    else if (localStorage.getItem('vehicleId') && fitId == 0 && !isCrossbar)
                        setFitMessage('#666', 'Rack System Required (<a href="/collections/truck-rack-systems">Shop</a>)', 'unknown');
                    else if (localStorage.getItem('fitId') == '-4')
                        setFitMessage('#666', 'We cannot confirm compatibility with your rack system. ');
                    else
                        setFitMessage('', '');
                }
                else if (data == -3) {
                    setFitMessage('#666', 'Ensure the perfect fit on a hitch receiver <a target="_blank" href="http://yakweb-assets.s3.us-west-2.amazonaws.com/HitchFitTips.pdf">here</a>', 'unknown');

                }
              else if (data == -4 && !isMOD) {
                 if(vehicleId > 0)
                    setFitMessage('#666', 'We cannot confirm compatibility with your vehicle.', 'unknown');
                 else
                    setFitMessage('', '');
                }
                else if (data == -5 && isTent)
                    setFitMessage('#666', 'We cannot confirm compatibility with your rack system, please read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>.', 'warning');
                else if (isLNL && (data == -5 || data == -4)) {
                    setFitMessage('#666', 'We cannot confirm compatibility with your vehicle, please read our <a href="https://assets.yakima.com/product/instructions/8005044/1" target="_blank">LockNLoad Vehicle Evaluation Guidelines and Best Practices</a>.', 'warning');
                    jQuery('.template-product').removeClass('nofit');

                }
               else if (data == -5) {
                    setFitMessage('#666', 'We cannot confirm compatibility with your vehicle, please contact <a href="/pages/contact-us">customer service</a> for more information.', 'unknown');
                    jQuery('.template-product').removeClass('nofit');

                }
              else if (data == -6) {
                    setFitMessage('#666', 'This vehicle configuration is still being evaluated for a fit.  Please check back later for updated information.', 'unknown');
                    jQuery('.template-product').removeClass('nofit');

                }
                if (productFit > 0) {
                      if (data == 1 && fitId == 0 && !systemPage && !isMOD && !isCrossbar) {
                      if(localStorage.getItem('isTruck') == 'true')
                        setFitMessage('#666', 'Rack System Required (<a href="/collections/truck-rack-systems">Shop</a>)', 'unknown');
                      else
                        setFitMessage('#666', 'Rack System Required (<a href="/product-type/tower-system">Shop</a>)', 'unknown');

                    }
                    else {

                        setFitMessage('#64a70b', ' Fits your ' + vehName + '', 'fit');
                        if (isLNL)
                            jQuery('#attachment-bar .pill').hide();

                        jQuery('.template-product').removeClass('nofit');
                        var url =  yakimaApiUrl2 + '/fitnote/GetFitNotes/' + fitId + '/' + currentSku;
                        jQuery.get(url, function (data) {
                          console.log('fitnotes', data);
                            jQuery.each(data, function (i, e) {
                                setFitMessage('Yellow', e.note);
                            });
                        });
                    }

                }
                if (isLNL && data !== -1) {
                    var fid = fitId;
                    if (jQuery('#attachment-tower').hasClass('selected'))
                        fid = localStorage.getItem('towerSystemId');
                    jQuery('.tower-platform-size .platform').each(function () {
                        var platform = jQuery(this);
                        var dataSku = jQuery(this).attr('data-sku');
                        var url =  yakimaApiUrl2 + '/fitcheck/GetFitCheck/' + fid + '/' + dataSku + '/' + vehicleId + '/' + rooftypeId;
                       
                        console.log(url);
                        jQuery.get(url, function (data) {
                            if (data > 0) {
                                jQuery(platform).find('.pill').removeClass('yellow').addClass('red').text('Recommended');
                            }
                        });
                    });
                }
            });
        }
   // }

}

function setFitMessage(color, content, cls) {
  var systemPage = jQuery('#shopify-section-system-template').length > 0 || jQuery('#shopify-section-mod-system').length > 0;
   if(color != null && color.length > 0) {
      jQuery('#fitCurrentVehicle').removeClass('blank').html('<p><span class="dot ' + cls + '" style="color: ' + color + ';"></span> ' + content + (systemPage ? '<a class="fmc-edit" onclick="initInlineFit();">Edit</a>' : '') + '</p>');
   }
  else 
   {
     
     if(systemPage)
      jQuery('#fitCurrentVehicle').addClass('blank').html('Add Vehicle To Select Options<br/><div class="inline-fmc">Fit My Vehicle <span class="plus" onclick="initInlineFit();">+</span></div>');
     else
       jQuery('#fitCurrentVehicle').hide();
   }
  
}
function initInlineFit() {
    var vehicleId = localStorage.getItem('vehicleId');
  var inlinefmc = '<select id="year-selector"></select><select id="make-selector"></select><select id="model-selector"></select><select id="type-selector" style="display: none;"></select><select id="bedlength-selector" style="display: none;"></select><select id="rooftype-selector" style="display: none;"></select>';
  if(vehicleId != null && vehicleId.length > 0)
    inlinefmc += '<a class="removeVehicle" onclick="removeVehicle();">Remove Vehicle</a>';
  jQuery('#fitCurrentVehicle').html('Add Vehicle To Select Options<br/><div class="inline-fmc">Fit My Vehicle <span class="plus" onclick="fitCheck();">-</span>' + inlinefmc + '</div>');
  loadYears();
}
 function initCollectionFMC() {
      var vehicleId = localStorage.getItem('vehicleId');
    var fmc = 'Fit My Vehicle <span class="plus" onclick="showInlineFMC();">+</span>';
     if(localStorage.getItem('year') != null && localStorage.getItem('make-name') != null && localStorage.getItem('model-name') != null)
      {
        fmc = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name') + '<a class="fmc-edit" onclick="showInlineFMC();">Edit</a>';
      }
      var inlinefmc = '<select id="year-selector"></select><select id="make-selector"></select><select id="model-selector"></select><select id="type-selector" style="display: none;"></select><select id="bedlength-selector" style="display: none;"></select><select id="rooftype-selector" style="display: none;"></select>';
    if(vehicleId != null && vehicleId.length > 0)
      inlinefmc += '<a class="removeVehicle" onclick="removeVehicle();">Remove Vehicle</a>';
      jQuery('.filters-toolbar__item-wrapper .ss-facet-container .collection-fmc').remove();
      jQuery('.filters-toolbar__item-wrapper .ss-facet-container').prepend('<div class="collection-fmc inline-fmc">' + fmc + '<div id="collection-fmc" style="display: none;">' + inlinefmc + '</div></div>');
      loadYears();
  }
function showInlineFMC() {
  jQuery('#collection-fmc').show();
  jQuery('#collection-fmc span.plus').html('-');
}
function categoryPage() {
    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var towerCat = window.location.href.indexOf('collections/roof-rack-systems') > 0 || window.location.href.indexOf('collections/truck-rack-systems') > 0 || window.location.href.indexOf('collections/truck-systems') > 0;
    var fitCnt = jQuery('body.template-collection ul.grid li.grid__item').length - jQuery('body.template-collection ul.grid li.grid__item.inline-banner').length;
console.log('load category page', fitCnt);
  //setTimeout(function() {
    if (towerCat) {
        var listClass = 'grid grid--view-items';
      jQuery('#category-nofit').remove();
        jQuery('#shopify-section-collection-template .ss-content-container').first().append('<div id="category-nofit"><h2>Does Not Fit Your Vehicle</h2><ul class="' + listClass + '"></ul></div>');
        jQuery('.main .sidebar').hide();
        jQuery('.main .col-main').css('padding-top', '50px');
        jQuery('.toolbar').hide();
        initCollectionFMC();
    }
  var gridItems = [];
        var cnt = 0;
        
    var fitSkus = '';
    if(localStorage.getItem('fitSkus'))
        fitSkus = localStorage.getItem('fitSkus');
    if(fitId > 0 && fitSkus.length == 0){
      var url =  yakimaApiUrl2 + '/fitcheck/GetFitSkus/' + fitId;
        console.log(url);
        jQuery.get(url, function (data) {
            if (data.length > 0) {
                localStorage.setItem('fitSkus', data);
            }
        });
    }

    var fitSystems = localStorage.getItem('fitSystems');
     if(vehicleId > 0 && fitSystems == null){
        var url = yakimaApiUrl2 + '/fit/getSystems/US/' + vehicleId + '/' + rooftypeId;
       console.log(url);
          jQuery.get(url, function (data) {
              if (data.length > 0) {
                localStorage.setItem('fitSystems', data);
                fitSystems = data;
              }
           });
      }
    if(vehicleId > 0 && towerCat)
      jQuery('span.ss-results-count-total').first().text(0);
    jQuery('body.template-collection ul.grid li.grid__item').each(function () {
        var productItem = this;
        var sku = jQuery(this).find('.product-sku').first().text().toLowerCase();
      
        var tags = jQuery(this).find('.product-tags').first().text();
      jQuery(productItem).show();

        if(tags.indexOf('ebike_rated') >= 0) {
          jQuery(productItem).find('.grid-view-item').first().append('<img class="ebike" src="http://yakimaassets.s3.us-west-2.amazonaws.com/BikeRated.png" alt="eBike Rated"/>');
        }
      
        if(tags.indexOf('modaward') >= 0) {
          jQuery(productItem).find('.grid-view-item').first().append('<img class="productFlag" src="http://yakimaassets.s3.us-west-2.amazonaws.com/ActiveLifestyleInnocationAwards.png"/>');
        }
        if(jQuery(this).find('div.ss-inline-banner').length > 0) {
          jQuery(this).addClass('inline-banner');
          console.log('inline banner found');
        }
       if(vehicleId != null) {
        if(tags.indexOf('hitchrequired') >= 0) {
          jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot unknown">•</span>Confirm Hitch Dimensions</span></span>');
        } 
        if(tags.indexOf('fitrequired') >= 0 || sku.indexOf('system') > 0) {
          
          if(vehicleId == 0) {
             jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot unknown">•</span>Vehicle info needed</span></span>');
          }
          else if(fitId == 0 || towerCat) 
          {
            if(towerCat) {
              
                 if(fitSystems && fitSystems.indexOf(sku.replace('-system', '').replace('-se', '-shadow-edition')) >= 0) {
                  jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit compatible"><span class="text"><span class="dot fit">•</span>Compatible</span></span>');
                   cnt++;
                   jQuery('span.ss-results-count-total').first().text(cnt);
    
                 }
                else {
                    if(jQuery(this).find('div.ss-inline-banner').length > 0) { console.log('inline banner found');}
                  jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot nofit">•</span>Not Compatible</span></span>');
                   // jQuery('#category-nofit ul.grid').append(jQuery(productItem).detach().addClass('widescreen--one-third'));
                  jQuery(productItem).hide();
                }
            }
            else 
              jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot unknown">•</span>System Required</span></span>');
          }
          else if(fitSkus.indexOf(sku) >= 0)  {
            jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit compatible"><span class="text"><span class="dot fit">•</span>Compatible</span></span>');
          }
          else if(fitSystems && fitSystems.indexOf(sku.replace('-system', '').replace('-se', '-shadow-edition')) >= 0) {
            jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit compatible"><span class="text"><span class="dot fit">•</span>Compatible</span></span>');
          }
          else {
            jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot nofit">•</span>Not Compatible</span></span>');
          }
        } 
      }
   });
  if(towerCat) {
  //  setTimeout(function() {
      jQuery('#collection-nofit').remove();
       if(jQuery('span.ss-results-count-total').first().text() == '0')
       {
         if(window.location.href.indexOf('collections/truck') > 0) {
            var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
            jQuery('#searchspring-content').after("<div id='collection-nofit'><p>You are currently shopping for your " + vehName + "</p><a class='btn' onclick='fmcModalInit();'>Update my Vehicle</a></div>");
         }
         else
          jQuery('li.inline-banner').show();
        }
      else if (vehicleId > 0) {
      //  jQuery('li.inline-banner').hide();
      }
   
 // }, 500);
  }
}

function getSku(systemName) {
  if(systemName == "skyline-system") return "8000163";
  if(systemName == "skyline-fx-system") return "8000170,8000171,8000172,8000173,8000174,8000181,8000182";
  if(systemName == "timberline-system") return "8000164";
  if(systemName == "timberline-fx-system") return "8000175,8000176,8000177,8000178,8000179";
  if(systemName == "ridgeline-system") return "8000145";
  if(systemName == "sightline-system") return "8001635";
  if(systemName == "sightline-fx-system") return "8000461,8000462,8000463,8000464";
  if(systemName == "baseline-system") return "8000162";
  if(systemName == "baseline-fx-system") return "8000165,8000166,8000167,8000168,8000169,8000180";
  if(systemName == "bedrock-hd-system") return "8001160";
  if(systemName == "1A-raingutter-system") return "8000101";
  if(systemName == "outdoorsman-system") return "8001136,8001137";
  if(systemName == "overhaul-hd-system") return "8001151";
  if(systemName == "overhaul-tonneau") return "8001151";
  if(systemName == "outpost-hd-system") return "8001152";
  if(systemName == "outpost-tonneau") return "8001152";
  if(systemName == "tracktower-system") return "8000198,8000199";
  if(systemName == "ribcage-system") return "8001051,8001052";
  if(systemName == "ruggedline-system") return "8005065,8005066,8005067,8005068,8005069,8005070";
  if(systemName == "locknload-system") return "8005044,8005045,8005046,8005047,8005048,8005049";
}
function windshieldPage() {
    var fitId = localStorage.getItem('fitId');
    if (fitId && fitId.length > 0) {
        var url = yakimaApiUrl2 + '/component/GetComponents/US/' + fitId + '/0/0/false/true/false';

        jQuery.get(url, function (data) {
            console.log(data);

            jQuery.each(data, function (i, e) {
                var psku = e.sku;
                if (psku.indexOf('800501') == 0) {
                    jQuery('#product-options-wrapper .cs-options li.cs-selected').removeClass('cs-selected');
                    jQuery('#product-options-wrapper .cs-options li').each(function () {
                        var size = jQuery(this).find('span').first().text();
                        if (e.name.indexOf(size) >= 0) {
                            jQuery(this).addClass('cs-selected').click();
                            jQuery('#product-options-wrapper .cs-select').removeClass('cs-active');
                        }
                    });
                }
            });
        });
    }
}

function cartPopup() {
    var fitId = localStorage.getItem('fitId');

  if(fitId != '0') {
    var url =  yakimaApiUrl2 + '/fitnote/GetFitNotes/' + fitId + '/CART';
      console.log(url);
      jQuery.get(url, function (data) {
          jQuery.each(data, function (i, e) {
            jQuery('.cart-popup__content').prepend('<p style="color: #811a1e; font-size: 0.9em;padding: 10px;margin:0;">* ' + e.note + '</p>');
          });
      });
    
    jQuery('.cart-items .cart-item').each(function () {
        var cartItem = this;
      var sku = jQuery(this).find('.list-view-item__sku p').first().text().replace('SKU: # ', '');

      
        var url =  yakimaApiUrl2 + '/fitnote/GetFitNotes/' + fitId + '/' + sku;
        console.log(url);
        jQuery.get(url, function (data) {
            jQuery.each(data, function (i, e) {
                if(e.skuFilter.indexOf('+') <= 0 && e.note != null) //Ignore the combined SKU filters, like the Roundbar warnings
                    jQuery(cartItem).find('.list-view-item__sku').append('<p style="color: #811a1e; clear: both; ">* ' + e.note + '</p>');
            });
        });
        

    });
  }
  
  
}
function callAjax(url, failCnt) {
    console.log(url);
    new Ajax.Request(url, {
        method: 'post',
        onFailure: function (response) {
            failCnt++;
            if (failCnt > 5)
                alert('Ajax call failed: ' + url);
            else
                callAjax(url, failCnt);
        }
    });
}
